import { API_BASE } from "./Base";

export { API_BASE };

export const UploadSingleFileAPI = new API_BASE("/uploads/upload-single-file");
export const UploadMultipleFileAPI = new API_BASE(
  "/uploads/upload-multiple-files",
);
export const CompanyProfileAPI = new API_BASE("/company_profile");
export const CategoriesAPI = new API_BASE("/categories");
export const CategoriesWithHierarchyAPI = new API_BASE("/categories/hierarchy");
export const PagesAPI = new API_BASE("/pages");
export const TeamMembersAPI = new API_BASE("/team_members");
export const TeamMembersCategoryAPI = new API_BASE("/team_members_category");
export const FaqsAPI = new API_BASE("/faq");
export const FeaturesAPI = new API_BASE("/features");
export const BannersAPI = new API_BASE("/banners");
export const AdRulesAPI = new API_BASE("/ad-rules");
export const StatusesAPI = new API_BASE("/statuses");
export const AdsAPI = new API_BASE("/ads");

export const SettingsAPI = new API_BASE("/Oram/Settings");
export const UpdateSettingsAPI = new API_BASE("/Oram/Settings");

export const MenusAPI = new API_BASE("/Agency/Menus");
export const LibraryAPI = new API_BASE("/Agency/Library");
export const ContactAPI = new API_BASE("/Agency/Contact");
export const ContactsAPI = new API_BASE("/Agency/Contacts");

// export const RoleAPI = new API_BASE("/Administration/Role");
export const UpdateProfileAPI = new API_BASE("/Administration/UpdateProfile");
export const RolePermissionsAPI = new API_BASE(
  "/Administration/RolePermissions",
);
export const UsersAPI = new API_BASE("/Agency/Users");
export const SignUpUserAPI = new API_BASE("/Agency/SignUpUser");
export const RolesAPI = new API_BASE("/Agency/Roles");
export const UserRoleByIDAPI = new API_BASE("/Agency/UserRole");
export const UserRolesAPI = new API_BASE("/Agency/UserRoles");
export const RoleAPI = new API_BASE("/Agency/Role");

export const ForgetPasswordAPI = new API_BASE("/Authentication/Forgot");
export const InventoryAPI = new API_BASE("/Agency/AdInventory");
export const InventoryMediaFilesAPI = new API_BASE(
  "/Agency/InventoryMediaFiles",
);
export const AuthorityAPI = new API_BASE("/Agency/Authority");
export const AuthorityByCityAPI = new API_BASE("/Agency/AuthorityByCity");

export const AuthorityLogoAPI = new API_BASE("/Oram/AuthorityLogo");
export const AuthorityAgreementAPI = new API_BASE("/Oram/AuthorityAgreement");
export const SpaceTypeAPI = new API_BASE("/Agency/SpaceType");

export const ProposalAPI = new API_BASE("/Agency/Proposal");
export const CompaignAPI = new API_BASE("/Agency/Campaign");
export const CompaignsAPI = new API_BASE("/Agency/Campaigns");

export const CompaignRequestAPI = new API_BASE("/Agency/CampaignRequest");
export const CompaignRequestsAPI = new API_BASE("/Agency/CampaignRequests");
export const CustomersAPI = new API_BASE("/Agency/Customers");

export const ProposalByCampaignsAPI = new API_BASE("/Agency/Proposals");
export const SignUpAPI = new API_BASE("/Agency/SignUp");

export const LogProposalChatAPI = new API_BASE("/Agency/LogProposalChat");
export const ProposalChatsAPI = new API_BASE("/Agency/ProposalChats");
export const ProposalChatMarkAsReadAPI = new API_BASE(
  "/Agency/ProposalChatMarkAsRead",
);
export const SendProposalToCustomerAPI = new API_BASE(
  "/Agency/SendProposalToCustomer",
);
export const ChangePasswordAPI = new API_BASE("/Agency/ChangePassword");
export const ForgotPasswordAPI = new API_BASE("/Agency/Forgot");
export const AgencyDetailAPI = new API_BASE("/Agency/Detail");
export const ActivateAccountAPI = new API_BASE("/Agency/Activate");

export const ServiceAreasColumnsAPI = new API_BASE("/Oram/ServiceAreasColumns");
export const ServicesColumnsAPI = new API_BASE("/Oram/ServicesColumns");

export const ActivateAccountAgencyAPI = new API_BASE("/Agency/Activate");
export const ActivateAccountCustomerAPI = new API_BASE("/Oram/Activate");
export const CustomerUpdateAPI = new API_BASE("/Agency/Customer");
export const CampaignsAPI = new API_BASE("/Agency/Campaigns");

export const VendorsAPI = new API_BASE("/Agency/Vendors");
export const VendorUpdateAPI = new API_BASE("/Agency/Vendor");

export const SuperAdminLibraryAPI = new API_BASE("/SuperAdmin/Library");

export const UserProfileInfoAPI = new API_BASE("/Agency/UserProfile");
